import React from "react";
import { Briefcase, MapPin } from "lucide-react";
import NoDataFound from "../../../components/common/NoDataFound";
import "../../../components/layout/ModuleLayout.css";

interface User {
  name: string;
  empId: string;
  email: string;
  dept: string;
  avatar: string;
}

interface Posting {
  id: number;
  title: string;
  geography: string;
  type: string;
}

interface IdentityPositionsBodyProps {
  user: User;
  postings: Posting[];
}

const IdentityPositionsBody: React.FC<IdentityPositionsBodyProps> = ({
  user,
  postings,
}) => {
  return (
    <div className="netbody-card flex flex-col h-full">
      <div className="netbody-content">
        <div className="scroll-container-nofilters flex-1 overflow-hidden">
          {/* User profile details */}
          <div className="flex items-center gap-4 p-4 mb-4 bg-white border border-indigo-100 rounded-lg shadow-sm">
            <img
              src={user.avatar}
              alt="Profile"
              className="w-14 h-14 rounded-full border-2 border-indigo-200 flex-shrink-0"
            />
            <div>
              <h2 className="text-base font-bold text-gray-900 leading-tight">
                {user.name}
              </h2>
              <div className="flex items-center gap-2 text-xs text-gray-500 mt-0.5">
                <span>{user.empId}</span>
                <span>•</span>
                <span>{user.email}</span>
                {user.dept && (
                  <>
                    <span>•</span>
                    <span>{user.dept}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          {postings.length === 0 ? (
            <NoDataFound
              title="No Positions Found"
              message="No positions have been assigned to you."
            />
          ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {postings.map((post) => (
                <div
                  key={post.id}
                  className="p-4 border border-indigo-50 bg-indigo-50/30 rounded-lg flex items-center justify-between"
                >
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-white rounded-lg border border-indigo-100 shadow-sm">
                      <Briefcase className="w-6 h-6 text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900">{post.title}</h3>
                      <p className="text-sm text-gray-600 flex items-center gap-1">
                        <MapPin className="w-3 h-3" /> {post.geography}
                      </p>
                    </div>
                  </div>
                  <span className="px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600">
                    {post.type}
                  </span>
                </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IdentityPositionsBody;
